"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BehaviorCodeReactionResponseDto = void 0;
const mappable_base_1 = require("../../mappable.base");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const shared_1 = require("../shared");
const enums_1 = require("../../enums");
class BehaviorCodeReactionResponseDto extends mappable_base_1.MappableBase {
    constructor(options) {
        super();
        if (!options)
            return;
        this.id = options.id;
        this.triggerCount = options.triggerCount;
        this.printCopies = options.printCopies;
        this.points = options.points;
        this.reactionMultiplier = options.reactionsMultiplier;
        this.behaviorCode = options.behaviorCode;
        this.reaction = options.reaction;
        this.school = options.school;
        this.behaviorCodeId = options.behaviorCodeId;
        this.reactionId = options.reactionId;
        this.schoolId = options.schoolId;
        this.active = options.active;
        this.reactionType = options.reactionType;
    }
    getFields() {
        return [
            'id',
            'triggerCount',
            'printCopies',
            'points',
            'reactionMultiplier',
            'behaviorCode',
            'reaction',
            'school',
            'schoolId',
            'reactionId',
            'behaviorCodeId',
            'active',
            'reactionType',
        ];
    }
    id;
    triggerCount;
    printCopies;
    points;
    reactionMultiplier;
    behaviorCode;
    reaction;
    school;
    schoolId;
    reactionId;
    behaviorCodeId;
    active;
    reactionType;
    static mapBehaviorCodeReactions(entities) {
        return mappable_base_1.MappableBase.mapAll(entities, BehaviorCodeReactionResponseDto);
    }
}
exports.BehaviorCodeReactionResponseDto = BehaviorCodeReactionResponseDto;
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsPositive)(),
    __metadata("design:type", Number)
], BehaviorCodeReactionResponseDto.prototype, "id", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsPositive)(),
    __metadata("design:type", Number)
], BehaviorCodeReactionResponseDto.prototype, "triggerCount", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsPositive)(),
    __metadata("design:type", Number)
], BehaviorCodeReactionResponseDto.prototype, "printCopies", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], BehaviorCodeReactionResponseDto.prototype, "points", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], BehaviorCodeReactionResponseDto.prototype, "reactionMultiplier", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", shared_1.RelationDto)
], BehaviorCodeReactionResponseDto.prototype, "behaviorCode", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", shared_1.RelationDto)
], BehaviorCodeReactionResponseDto.prototype, "reaction", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", shared_1.RelationDto)
], BehaviorCodeReactionResponseDto.prototype, "school", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsPositive)(),
    __metadata("design:type", Number)
], BehaviorCodeReactionResponseDto.prototype, "schoolId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsPositive)(),
    __metadata("design:type", Number)
], BehaviorCodeReactionResponseDto.prototype, "reactionId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsPositive)(),
    __metadata("design:type", Number)
], BehaviorCodeReactionResponseDto.prototype, "behaviorCodeId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], BehaviorCodeReactionResponseDto.prototype, "active", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsEnum)(enums_1.ReactionTypeEnum),
    __metadata("design:type", String)
], BehaviorCodeReactionResponseDto.prototype, "reactionType", void 0);
